<!-- market.component.html -->

<div class="fullheight2">
    <mat-tab-group #tab class="stickytabgroup" mat-align-tabs="center" mat-stretch-tabs="false" color="primary"
        (selectedTabChange)="changeQueryTab($event)">
        <!-- Produkte Tab -->
        <mat-tab [disabled]="tabsDisabled[0]">
            <ng-template mat-tab-label>PRODUKTE</ng-template>
            <ng-template matTabContent>
                <div class="fullheight">
                    <div class="centerSpinner" *ngIf="spinner">
                        <mat-spinner></mat-spinner>
                    </div>

                    <mat-sidenav-container class="sidenav-container" style="height: 100%;">
                        <!-- Left filter -->
                        <mat-sidenav #drawer class="sidenav"
                            [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
                            [mode]="(isHandset$ | async) ? 'over' : 'side'" [disableClose]="true"
                            [opened]="(isHandset$ | async) === false && !showDetails">
                            <div *ngIf="marketScreenState === 'PRODUCT'" class="sidefilter"
                                style="display: flex; flex-flow: column; height: 100%;">
                                <app-market-place-side-filter [externalSearch$]="searchInput$"
                                    (activeFiltersChange)="onActiveFiltersChange($event)"
                                    (resetAll)="resetAllFilters()"></app-market-place-side-filter>
                            </div>
                        </mat-sidenav>

                        <!-- Content -->
                        <mat-sidenav-content style="margin-top: 34px; padding-top: 0;">
                            <!-- Header -->
                            <ng-container
                                *ngTemplateOutlet="headerTemplate; context: { chipList: activeFilterChips, total: totalNrOfItems }"></ng-container>

                            <!-- Initial skeletons -->
                            <ng-container *ngIf="spinner">
                                <ng-container
                                    *ngTemplateOutlet="skeletonGrid;  context: { count: 36, gridClass: 'grid' }"></ng-container>
                            </ng-container>

                            <!-- Grid / Infinite scroll -->
                            <app-infinite-scroll *ngIf="!spinner" class="grid" (scrolled)="onScroll()" #gridContainer>
                                <div class="filterSpinner" *ngIf="marketPlaceFilterService.filterSpinner">
                                    <mat-spinner></mat-spinner>
                                </div>

                                <div #target class="card2" *ngFor="let item of displayItem">
                                    <app-display-item
                                        *ngIf="!this.marketPlaceFilterService.filterSpinner && this.selectedFilter != 'Datenangebote'"
                                        (click)="openProductDialog(item.name,item)"
                                        [focus]="checkIfFocusForProduct(item)" [isProduct]="true" [itemInfo]="item"
                                        [bookmarked]="isLoggedIn() ? isBookmarked(item.id, 1) : null">
                                    </app-display-item>

                                    <app-display-item
                                        *ngIf="!this.marketPlaceFilterService.filterSpinner && this.selectedFilter == 'Datenangebote'"
                                        (click)="openAssetDialog(item.name, item)"
                                        [focus]="checkIfFocusForProduct(item)" [isProduct]="true" [itemInfo]="item">
                                    </app-display-item>
                                </div>

                                <!-- Incremental skeletons when fetching more -->
                                <div class="filterSpinner" *ngIf="displaySpinner">
                                    <mat-spinner></mat-spinner>
                                </div>
                                <ng-container
                                    *ngTemplateOutlet="skeletonGrid; context: { count: 8, gridClass: 'grid' , displayContents: true}"></ng-container>
                            </app-infinite-scroll>

                            <!-- No results -->
                            <div *ngIf="!spinner && showNoResults">
                                <ng-container [ngTemplateOutlet]="noResults"></ng-container>
                            </div>
                        </mat-sidenav-content>

                        <!-- Right details -->
                        <mat-sidenav [opened]="showDetails" mode="side" position="end" class="product-details">
                            <app-product-detail-display *ngIf="showDetails" [actualProduct]="actualProduct"
                                (goBack)="goBack()"
                                (reloadDisplayItems)="loadDisplayItem($event)"></app-product-detail-display>
                        </mat-sidenav>
                    </mat-sidenav-container>
                </div>
            </ng-template>
        </mat-tab>

        <!-- Zertifizierungen Tab -->
        <mat-tab [disabled]="tabsDisabled[1]">
            <ng-template mat-tab-label>ZERTIFIZIERUNGEN</ng-template>
            <ng-template matTabContent>
                <div class="fullheight">
                    <div class="centerSpinner" *ngIf="spinner">
                        <mat-spinner></mat-spinner>
                    </div>

                    <mat-sidenav-container class="sidenav-container" style="height: 100%;">
                        <!-- Left filter -->
                        <mat-sidenav #drawer class="sidenav"
                            [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
                            [mode]="(isHandset$ | async) ? 'over' : 'side'"
                            [opened]="(isHandset$ | async) === false && !showDetails" [disableClose]="true">
                            <div *ngIf="marketScreenState === 'CERTIFICATION'"
                                style="display: flex; flex-flow: column; height: 100%; position: fixed;">
                                <app-market-place-side-filter [externalSearch$]="searchInput$"
                                    (activeFiltersChange)="onActiveFiltersChange($event)"
                                    (resetAll)="resetAllFilters()"></app-market-place-side-filter>
                            </div>
                        </mat-sidenav>

                        <!-- Content -->
                        <mat-sidenav-content style="padding-top: 0; height: 100%;">
                            <!-- Header -->
                            <ng-container
                                *ngTemplateOutlet="headerTemplate; context: { chipList: activeFilterChips, total: totalNrOfItems }"></ng-container>

                            <!-- Initial skeletons -->
                            <ng-container *ngIf="spinner">
                                <ng-container
                                    *ngTemplateOutlet="skeletonGrid; context: { count: 36, gridClass: 'grid' }"></ng-container>
                            </ng-container>

                            <app-infinite-scroll class="grid" (scrolled)="onScroll()" #gridContainer>
                                <div class="filterSpinner" *ngIf="marketPlaceFilterService.filterSpinner">
                                    <mat-spinner></mat-spinner>
                                </div>

                                <div #target class="card2" *ngFor="let item of displayItem">
                                    <app-display-item *ngIf="!marketPlaceFilterService.filterSpinner"
                                        (click)="changeQueryParams(item.id)" [focus]="checkIfFocusForCertificate(item)"
                                        [isCertification]="true" [itemInfo]="item"
                                        [bookmarked]="isLoggedIn() ? isBookmarked(item.id, 0) : null"></app-display-item>
                                </div>

                                <!-- Incremental skeletons when fetching more -->
                                <div class="filterSpinner" *ngIf="displaySpinner">
                                    <mat-spinner></mat-spinner>
                                </div>
                                <ng-container
                                    *ngTemplateOutlet="skeletonGrid; context: { count: 8, gridClass: 'grid', displayContents: true }"></ng-container>
                            </app-infinite-scroll>

                            <!-- No results -->
                            <div *ngIf="!spinner && showNoResults">
                                <ng-container [ngTemplateOutlet]="noResults"></ng-container>
                            </div>
                        </mat-sidenav-content>

                        <!-- Right details -->
                        <mat-sidenav [opened]="showDetails" mode="side" position="end" class="product-details">
                            <app-certification-detail-display *ngIf="showDetails"
                                [actualCertification]="actualCertification"
                                (goBack)="goBack()"></app-certification-detail-display>
                        </mat-sidenav>
                    </mat-sidenav-container>
                </div>
            </ng-template>
        </mat-tab>

        <!-- Anbieter Tab -->
        <mat-tab [disabled]="tabsDisabled[2]">
            <ng-template mat-tab-label>Organisationen</ng-template>
            <ng-template matTabContent>
                <div class="fullheight">
                    <div class="centerSpinner" *ngIf="spinner">
                        <mat-spinner></mat-spinner>
                    </div>

                    <mat-sidenav-container class="sidenav-container" style="height: 100%;">
                        <!-- Left filter -->
                        <mat-sidenav #drawer class="sidenav"
                            [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
                            [mode]="(isHandset$ | async) ? 'over' : 'side'"
                            [opened]="(isHandset$ | async) === false && !showDetails" [disableClose]="true">
                            <div *ngIf="marketScreenState === 'ORGANISATION'"
                                style="display: flex; flex-flow: column; height: 100%; position: fixed;">
                                <app-market-place-side-filter [externalSearch$]="searchInput$"
                                    (activeFiltersChange)="onActiveFiltersChange($event)"
                                    (resetAll)="resetAllFilters()"></app-market-place-side-filter>
                            </div>
                        </mat-sidenav>

                        <!-- Content -->
                        <mat-sidenav-content style="padding-top: 0; height: 100%;">
                            <!-- Header -->
                            <ng-container
                                *ngTemplateOutlet="headerTemplate; context: { chipList: activeFilterChips, total: totalNrOfItems }"></ng-container>

                            <!-- Initial skeletons -->
                            <ng-container *ngIf="spinner">
                                <ng-container
                                    *ngTemplateOutlet="skeletonGrid; context: { count: 36, gridClass: 'grid' }"></ng-container>
                            </ng-container>

                            <app-infinite-scroll class="grid" (scrolled)="onScroll()">
                                <div class="filterSpinner" *ngIf="marketPlaceFilterService.filterSpinner">
                                    <mat-spinner></mat-spinner>
                                </div>

                                <div #target class="card2" *ngFor="let item of displayItem">
                                    <app-display-item *ngIf="!marketPlaceFilterService.filterSpinner"
                                        (click)="openOrganisationDialog(item.id)" [focus]="checkIfFocusForOrga(item)"
                                        [isProvider]="true" [itemInfo]="item"
                                        [bookmarked]="isLoggedIn() ? isBookmarked(item.id, 2) : null"></app-display-item>
                                </div>

                                <!-- Incremental skeletons when fetching more -->
                                <div class="filterSpinner" *ngIf="displaySpinner">
                                    <mat-spinner></mat-spinner>
                                </div>
                                <ng-container
                                    *ngTemplateOutlet="skeletonGrid; context: { count: 8, gridClass: 'grid' , displayContents: true}"></ng-container>
                            </app-infinite-scroll>

                            <!-- No results -->
                            <div *ngIf="!spinner && showNoResults">
                                <ng-container [ngTemplateOutlet]="noResults"></ng-container>
                            </div>
                        </mat-sidenav-content>


                    </mat-sidenav-container>
                </div>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>

<!-- Filter toggle bar only for PRODUCT state -->
<div *ngIf="marketScreenState === 'PRODUCT'" class="filter-tab-bar">
    <div class="scd-header-shadow"></div>
    <mat-button-toggle-group [value]="selectedFilter" (change)="onFilterChanged($event.value)"
        [hideSingleSelectionIndicator]="hideSingleSelectionIndicator()" appearance="standard" class="filter-buttons">
        <mat-button-toggle *ngFor="let item of visibleCategoryItems" [value]="item.name">
            {{ item.name }}
        </mat-button-toggle>
    </mat-button-toggle-group>
</div>

<!-- Global loading overlay -->
<div *ngIf="loading" class="loading-overlay-spinner">
    <mat-spinner></mat-spinner>
</div>

<!-- Shared templates -->
<ng-template #headerTemplate let-total="total" let-chipList="chipList">
    <div class="header-sticky bg-surface" style="
      position: sticky;
      width: -webkit-fill-available;
      z-index: 9999;
      height: auto;
      top: 0;
      padding-top: 1rem;
      margin-bottom: 0.8rem;
      margin-left: -1rem;
      margin-right: -1rem;
    ">
        <div class="searchContainer">
            <div class="search-field-container">
                <mat-form-field class="search-input-field">
                    <mat-icon matPrefix color="primary">search</mat-icon>
                    <mat-label>Suche</mat-label>
                    <input matInput placeholder="Schlagwort" (input)="onMainSearchInput($event.target.value)"
                        [(ngModel)]="searchText" />
                </mat-form-field>
                <span>{{ total }} Ergebnisse</span>
            </div>

            <mat-form-field>
                <mat-label>Sortierung nach</mat-label>
                <mat-select [(ngModel)]="sortMethod" name="sortMethod"
                    (selectionChange)="onSortSelectionChange($event)">
                    <mat-option *ngFor="let method of sortOptions" [value]="method.name">
                        {{ method.title }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="searchResultsBar">
            <mat-chip-list style="display: inline-flex; gap: 10px; flex-wrap: wrap;">
                @for (filter of chipList; track filter.id) {
                <mat-basic-chip class="btn-chip-selected" (removed)="removeFilterChip(filter)" removable>
                    @if (filter.category === 'rating') {
                    <div class="ratingStar">
                        <app-star [rating]="filter.id === 0 ? 0 : filter.id"></app-star>
                    </div>
                    } @else {
                    {{ filter.label }}
                    }
                    <mat-icon matChipRemove>cancel</mat-icon>
                </mat-basic-chip>
                }
            </mat-chip-list>
        </div>
    </div>
</ng-template>

<!-- Reusable skeleton grid -->
<ng-template #skeletonGrid let-count="count" let-gridClass="gridClass" let-display="displayContents">
    <ngx-skeleton-loader *ngIf="!display && (displaySpinner || spinner || marketPlaceFilterService.filterSpinner)"
        [count]="count" animation="pulse" appearance="square" [class]="gridClass" [theme]="{
      'border-radius': '5px',
      'height': '330px',
      'width': 'auto',
      'min-width': '320px',
      'border': '1px solid var(--app-outline)',
      'background-color': 'rgba(var(--app-primary-rgb), 0.06)',
      'gap': '16px'
    }"></ngx-skeleton-loader>

    <ngx-skeleton-loader *ngIf="display && (displaySpinner || spinner || marketPlaceFilterService.filterSpinner)"
        [count]="count" animation="pulse" appearance="square" [class]="gridClass" style="display: contents" [theme]="{
      'border-radius': '5px',
      'height': '330px',
      'width': 'auto',
      'min-width': '320px',
      'border': '1px solid var(--app-outline)',
      'background-color': 'rgba(var(--app-primary-rgb), 0.06)',
      'gap': '16px'
    }"></ngx-skeleton-loader>
</ng-template>

<ng-template #noResults>
    <h1 style="font-size: xx-large">Keine Ergebnisse gefunden.</h1>
    <br />
    <h1>Versuchen Sie, die Filter zu ändern.</h1>
</ng-template>
<ng-template #organisationDetailsDialog>
    <app-organisation-detail-display [actualProduct]="actualOrganisation"
        (goBack)="closeOrganisationDialog()"></app-organisation-detail-display>
</ng-template>
